import base from './baseApi';

const { urls, methods, execute } = base();

export type FontFileFormat = 'woff2' | 'woff' | 'truetype' | 'opentype';
export type FontStyle = 'normal' | 'italic';
export type FontStatus = 'ACTIVE' | 'INACTIVE';

export interface CustomFont {
   id: string;
   displayName: string;
   fontFamily: string;
   weight: number;
   style: FontStyle;
   fileFormat: FontFileFormat;
   s3Path: string;
   fileSize: number;
   status: FontStatus;
   created?: string;
   modified?: string;
}

export interface FontListResponse {
   entities: CustomFont[];
   totalEntities: number;
}

export const listFonts = () => {
   return execute(methods.GET, urls.fonts.list, {}, { limit: -1 });
};

export const listFontsAdmin = () => {
   return execute(methods.GET, urls.fonts.listAdmin, { authorization: true }, { limit: -1 });
};

export interface UploadFontPayload {
   file: File | Blob;
   displayName: string;
   fontFamily: string;
   weight?: number;
   style?: FontStyle;
}

export const uploadFont = (payload: UploadFontPayload) => {
   return execute(methods.POST, urls.fonts.base, { authorization: true }, payload, true);
};

export interface UpdateFontPayload {
   displayName?: string;
   fontFamily?: string;
   weight?: number;
   style?: FontStyle;
   status?: FontStatus;
}

export const updateFont = (id: string, payload: UpdateFontPayload) => {
   return execute(methods.PATCH, urls.fonts.byId.replace(':id', id), { authorization: true }, payload);
};

export const deleteFont = (id: string) => {
   return execute(methods.DELETE, urls.fonts.byId.replace(':id', id), { authorization: true });
};
